export enum SubscriptionStatus {
    REDIRECTING = 'redirecting',
    VERIFYING = 'verifying',
    SUCCESS = 'success',
    FAILURE = 'failure',
    DOWNGRADE = 'downgrade'
  }
  
  export interface StatusConfig {
    title: string;
    subtitle: string;
    warning: string;
    icon: string;
    iconClass: string;
    warningClass: string;
    warningIcon: string;
    infoBoxClass: string;
    infoIconClass: string;
    infoTextClass: string;
    showProgress: boolean;
  }
  
  export const STATUS_CONFIGS: Record<SubscriptionStatus, StatusConfig> = {
    [SubscriptionStatus.REDIRECTING]: {
      title: 'Redirecting to Payment Gateway',
      subtitle: 'Please wait while we securely redirect you...',
      warning: 'Please do not close this window, press the back button, or refresh the page. You will be taken to our secure payment partner to complete your subscription.',
      iconClass: 'redirecting',
      icon: 'open_in_new',
      warningClass: 'bg-transparent border-accent',
      warningIcon: 'info',
      infoBoxClass: 'default',
      infoIconClass: 'leg-settings-title',
      infoTextClass: 'fg-sb-text',
      showProgress: true
    },
    [SubscriptionStatus.VERIFYING]: {
      title: 'Verifying Your Subscription',
      subtitle: 'Please wait while we confirm your subscription status...',
      warning: 'Verification may take a few moments. Please do not close this window, refresh the page, or navigate away. We are confirming your payment and activating your plan.',
      iconClass: 'verifying',
      icon: 'sync',
      warningClass: 'bg-transparent border-accent',
      warningIcon: 'schedule',
      infoBoxClass: 'default',
      infoIconClass: 'leg-settings-title',
      infoTextClass: 'fg-sb-text',
      showProgress: true
    },
    [SubscriptionStatus.SUCCESS]: {
      title: 'Subscription Successful!',
      subtitle: 'Your subscription has been activated successfully.',
      warning: 'Your plan is now active. You will be redirected back to the plans page in a moment. Thank you for subscribing.',
      icon: 'check_circle',
      iconClass: 'success',
      warningClass: 'positive-toast border-positive',
      warningIcon: 'check_circle',
      infoBoxClass: 'success',
      infoIconClass: 'text-positive',
      infoTextClass: 'green',
      showProgress: false
    },
    [SubscriptionStatus.FAILURE]: {
      title: 'Subscription Failed',
      subtitle: 'We couldn\'t complete your subscription. Please try again.',
      warning: 'You will be redirected back to the plans page shortly. If the problem persists, please try again or contact support. Your payment has not been charged.',
      iconClass: 'failure',
      icon: 'cancel',
      warningClass: 'negative-toast border-negative',
      warningIcon: 'error',
      infoBoxClass: 'error',
      infoIconClass: 'text-negative',
      infoTextClass: 'red',
      showProgress: false
    },
    [SubscriptionStatus.DOWNGRADE]: {
      title: 'Plan Change Scheduled',
      subtitle: 'Your plan change has been scheduled.',
      warning: 'It will take effect at the end of your current billing period.',
      icon: 'check_circle',
      iconClass: 'success',
      warningClass: 'positive-toast border-positive',
      warningIcon: 'check_circle',
      infoBoxClass: 'success',
      infoIconClass: 'text-positive',
      infoTextClass: 'green',
      showProgress: false
    }
  };
  